<template>
    <div>
        <header class="mdui-appbar mdui-appbar-inset mdui-appbar-fixed mdui-text-color-white">
            <div class="mdui-toolbar mdui-color-theme">
                <span class="mdui-btn mdui-btn-icon mdui-ripple mdui-ripple-white" mdui-drawer="{target: '#main-drawer', swipe: true}"><i class="mdui-icon material-icons">menu</i></span>
                <a href="../" class="mdui-typo-headline mdui-hidden-xs">阴阳师语音</a>
                <a mdui-menu="{target: '#menu1'}" class="mdui-typo-title" style="cursor: pointer">{{title}}
                    <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-white">keyboard_arrow_down</i></a>
                <div class="mdui-toolbar-spacer"></div>
                <!--<span class="mdui-btn mdui-btn-icon mdui-ripple mdui-ripple-white" mdui-dialog="{target: '#dialog-docs-theme'}" mdui-tooltip="{content: '设置主题'}"><i class="mdui-icon material-icons">color_lens</i></span>-->

                <a href="https://www.coolapk.com/u/1118664/" target="_blank" class="mdui-btn mdui-btn-icon mdui-ripple mdui-ripple-white" mdui-tooltip="{content: '酷基<br>你好'}">
                    <svg class="mdui-icon coolapk" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" style="width: 36px;height:36px;">
                        <path fill="#ffffff" d="M315.2 343.093333c53.546667-12.8 111.52-1.92 158.72 25.76 34.986667 21.12 65.44 48.64 97.493333 73.706667-17.706667 12-35.253333 24.16-53.173333 35.84-32.746667-24.693333-62.933333-54.88-102.56-68.48-36.373333-12.533333-78.826667-14.4-113.386667 4.64-35.413333 18.773333-59.733333 57.333333-59.68 97.653333-1.066667 40.48 22.666667 79.733333 57.76 99.413334 37.813333 21.76 86.08 18.88 124.533334 0.32 47.626667-23.306667 80.32-67.146667 109.653333-109.813334 31.52-48.96 59.573333-100.053333 90.293333-149.493333 6.72-12.533333 22.506667-19.253333 36-14.133333 12.533333 4 17.92 16.96 23.893334 27.466666 47.466667 85.6 95.52 170.826667 143.573333 256.053334 7.52 13.653333 18.506667 27.84 13.866667 44.48-3.52 20.533333-30.826667 27.573333-46.4 16-66.24-49.066667-132.8-97.813333-198.933334-147.146667 16.373333-13.706667 34.933333-24.533333 52.373334-36.8 22.933333 17.013333 45.866667 34.08 68.906666 50.933333-22.026667-40.853333-45.6-80.8-67.893333-121.493333-42.613333 66.08-77.386667 138.773333-135.04 193.653333-41.386667 41.12-98.453333 69.226667-157.813333 65.973334-92.053333 4.213333-175.413333-78.773333-174.613334-170.346667-3.84-79.68 55.04-156 132.426667-174.186667z"></path>
                    </svg>
                </a>
                <a href="https://space.bilibili.com/32725934/" target="_blank" class="mdui-btn mdui-btn-icon mdui-ripple mdui-ripple-white" mdui-tooltip="{content: 'B with U'}">
                    <svg class="mdui-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36">
                        <path fill="#ffffff" d="M360.896 183.968L269.984 95.872s-14.208-17.472 9.824-37.248c24.16-19.648 25.376-10.912 33.504-5.472s135.2 130.816 135.2 130.816h-87.616z m301.952 3.264l90.912-88.096s14.208-17.472-9.824-37.248c-24.032-19.648-25.376-10.912-33.504-5.472s-135.2 130.816-135.2 130.816h87.616z m341.152 163.104c-3.264-137.984-123.168-164.192-123.168-164.192s-614.336-4.96-742.496 0C10.176 222.304 20 350.336 20 350.336s1.696 274.272-0.128 413.12c13.824 138.848 120.864 160.928 120.864 160.928s42.72 0.864 73.92 0.864c3.264 8.992 5.696 52.544 54.24 52.544 48.416 0 54.24-52.544 54.24-52.544s354.88-1.696 384.352-1.696c1.696 14.816 8.992 54.976 57.536 54.24 48.416-0.864 51.712-57.536 51.712-57.536s16.384-1.696 65.664 0c114.944-21.376 121.6-156.064 121.6-156.064s-1.568-275.872 0-413.856z m-98.912 439.232c0 21.728-17.248 39.456-38.464 39.456H167.2c-21.248 0-38.464-17.6-38.464-39.456V326.336c0-21.728 17.248-39.456 38.464-39.456h699.424c21.248 0 38.464 17.6 38.464 39.456v463.232zM202.4 457.152l205.344-39.456 15.52 77.184-203.648 39.456z m638.976 0l-205.344-39.456-15.648 77.184 203.776 39.456z m-418.08 191.392s45.152 81.312 95.264-26.336c48.416 105.088 101.824 27.904 101.824 27.904l30.336 19.776s-56.672 91.136-131.424 22.208c-63.232 68.928-129.728-21.952-129.728-21.952l33.728-21.6z"></path>
                    </svg>
                </a>
                <ul class="mdui-menu" id="menu1">
                    <li class="mdui-menu-item">
                        <router-link :to="{name: 'yysLink', query:{key: 'yys'}}" class="mdui-ripple">阴阳师</router-link>
                    </li>
                    <li class="mdui-divider"></li>
                    <li class="mdui-menu-item">
                        <router-link :to="{name: 'yysLink', query:{key: 'sp'}}" class="mdui-ripple">SP式神</router-link>
                    </li>
                    <li class="mdui-menu-item">
                        <router-link :to="{name: 'yysLink', query:{key: 'ssr'}}" class="mdui-ripple">SSR式神</router-link>
                    </li>
                    <li class="mdui-menu-item">
                        <router-link :to="{name: 'yysLink', query:{key: 'sr'}}" class="mdui-ripple">SR式神</router-link>
                    </li>
                    <li class="mdui-menu-item">
                        <router-link :to="{name: 'yysLink', query:{key: 'r'}}" class="mdui-ripple">R式神</router-link>
                    </li>
                </ul>
            </div>
        </header>
        <div class="mdui-drawer mdui-drawer-full-height" id="main-drawer">
            <div class="mdui-list" mdui-collapse="{accordion: true}" style="margin-bottom: 76px;">
                <router-link :to="{name: 'homeLink'}" @click.native="closeTab" class="mdui-list-item mdui-ripple">
                    <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-blue">home</i>
                    <div class="mdui-list-item-content">首页</div>
                    <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                </router-link>

                <div class="mdui-collapse-item">
                    <div class="mdui-collapse-item-header mdui-list-item mdui-ripple">
                        <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-red">people</i>
                        <div class="mdui-list-item-content">角色分类</div>
                        <i class="mdui-collapse-item-arrow mdui-icon material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="mdui-collapse-item-body mdui-list">
                        <router-link :to="{name: 'yysLink', query:{key: 'yys'}}" @click.native="closeTab" class="mdui-list-item mdui-ripple">
                            <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-teal">looks_one</i>
                            <div class="mdui-list-item-content">阴阳师</div>
                            <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                        </router-link>
                        <router-link :to="{name: 'yysLink', query:{key: 'sp'}}" @click.native="closeTab"  class="mdui-list-item mdui-ripple">
                            <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-deep-orange">looks_two</i>
                            <div class="mdui-list-item-content">SP式神</div>
                            <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                        </router-link>
                        <router-link :to="{name: 'yysLink', query:{key: 'ssr'}}" @click.native="closeTab" class="mdui-list-item mdui-ripple">
                            <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-indigo">looks_3</i>
                            <div class="mdui-list-item-content">SSR式神</div>
                            <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                        </router-link>
                        <router-link :to="{name: 'yysLink', query:{key: 'sr'}}" @click.native="closeTab" class="mdui-list-item mdui-ripple" id="assist">
                            <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-red">looks_4</i>
                            <div class="mdui-list-item-content">SR式神</div>
                            <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                        </router-link>
                        <router-link :to="{name: 'yysLink', query:{key: 'r'}}" @click.native="closeTab" class="mdui-list-item mdui-ripple">
                            <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-teal">looks_5</i>
                            <div class="mdui-list-item-content">R式神</div>
                            <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                        </router-link>
                    </div>
                </div>

                <a @click="search" class="mdui-list-item mdui-ripple">
                    <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-indigo">search</i>
                    <div class="mdui-list-item-content">搜索</div>
                    <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                </a>


                <div class="mdui-divider"></div>


                <a v-if="app" @click="building" class="mdui-list-item mdui-ripple">
                    <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-pink">show_chart</i>
                    <div class="mdui-list-item-content">大数据</div>
                    <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                </a>

                <div class="mdui-collapse-item mdui-collapse-item-open">
                    <div class="mdui-collapse-item-header mdui-list-item mdui-ripple">
                        <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-cyan">widgets</i>
                        <div class="mdui-list-item-content">App下载</div>
                        <i class="mdui-collapse-item-arrow mdui-icon material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="mdui-collapse-item-body mdui-list">
                        <a href="https://www.coolapk.com/apk/227193" target="_blank" class="mdui-list-item mdui-ripple ">
                            <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-green">android</i>
                            <div class="mdui-list-item-content">Android</div>
                            <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                        </a>
                        <a @click="building" v-if="app" class="mdui-list-item mdui-ripple ">iOS</a>
                        <a @click="building" v-if="app" class="mdui-list-item mdui-ripple ">UWP</a>
                    </div>
                </div>


                <a @click="callme" class="mdui-list-item mdui-ripple">
                    <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-green">near_me</i>
                    <div class="mdui-list-item-content">联系我</div>
                    <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                </a>

                <router-link :to="{name: 'aboutLink'}" @click.native="closeTab" class="mdui-list-item mdui-ripple">
                    <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-brown">info</i>
                    <div class="mdui-list-item-content">关于</div>
                    <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                </router-link>

                <router-link v-if="app" to="{name: 'logLink'}" @click.native="closeTab" class="mdui-list-item mdui-ripple">
                    <i class="mdui-list-item-icon mdui-icon material-icons mdui-text-color-cyan">description</i>
                    <div class="mdui-list-item-content">更新日志</div>
                    <i class="mdui-list-item-icon mdui-icon material-icons"></i>
                </router-link>

            </div>
        </div>



    </div>
</template>

<script>
    import mdui from 'mdui'
    import axios from 'axios'

    export default {
        name: "Header",
        data(){
            return{
                app: false,

            }
        },
        props:{
            title:{
                require: true,
                type: String
            },
        },
        methods:{
            closeTab(){
                let body_class = document.body.getAttribute("class");
                if(body_class.includes("mdui-locked")){
                    let inst = new mdui.Drawer('#main-drawer');
                    inst.toggle();
                }
            },
            building(){
                this.closeTab();
                this.$dialog
                    .alert('建设中，敬请期待^_^', {okText: '确定'})
                    .then(function(dialog) {
                        // console.log('Closed');
                    });
            },
            callme(){
                this.closeTab();
                this.$dialog
                    .alert('右上角找我（￣︶￣）↗<br>或者<a href=\'mailto:blueflauor@163.com\'>发邮件给我</a>', {html :true , okText: '确定'})
                    .then(function(dialog) {
                        // console.log('Closed');
                    });
            },
            search(){
                this.closeTab();
                let route = this.$router;
                let options = {
                    okText: '确定',  // 本地化确认按钮文字提示内容
                    cancelText: '取消',  //本地化关闭按钮文字提示内容
                    promptHelp: '请输入『角色名/CV』的关键字-->点击"[+:okText]"或按下Enter'
                };
                this.$dialog
                    .prompt({
                        title: "搜索",
                        // body: "请输入",
                    }, options)
                    .then(dialog => {
                        let value = document.getElementById("dg-input-elem").value;
                        // this.$dialog.alert(dialog.data || '[empty]')
                        route.push({name:'sLink',query:{key: dialog.data || value}});
                    })
                    .catch(() => {
                        // Triggered when dialog is dismissed by user
                        // console.log('Prompt dismissed');
                    });
            }
        }
    }
</script>

<style scoped>
    .coolapk{
        transform: translateX(-18px) translateY(-18px);
    }

</style>


// WEBPACK FOOTER //
// src/components/Header.vue